var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "camera-to-take-photos",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.607,
    height: 14.294,
    viewBox: "0 0 17.607 14.294",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7346",
    "data-name": "Path 7346",
    d: "M15.489,5.9H12.944V5.639a2.117,2.117,0,0,0-2.117-2.117H6.779A2.117,2.117,0,0,0,4.663,5.639V5.9H2.117A2.117,2.117,0,0,0,0,8.017V15.7a2.117,2.117,0,0,0,2.117,2.117H15.49A2.117,2.117,0,0,0,17.607,15.7V8.017A2.118,2.118,0,0,0,15.489,5.9ZM8.8,15.62a4,4,0,1,1,4-4A4,4,0,0,1,8.8,15.62Zm2.117-4A2.117,2.117,0,1,1,8.8,9.506,2.12,2.12,0,0,1,10.919,11.622Z",
    transform: "translate(0 -3.522)",
    fill: "#f93"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.2044838ff720cfaa6f613d17d1bf8c92.svg";
export { ForwardRef as ReactComponent };